import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import './campaignSale.css';
import '@fontsource/open-sauce-one';
import ProgressMeter from './components/progressMeter/progressMeter';
import baseURLGlobal from '../../utils/util';
import { SOURCE_HOME, directDeepLink } from '../webviewreboot/util';
import SleekCarousel from './components/sleekCarousel';

const Campaign = (props) => {
	const [data, setData] = useState();
	const baseUrl = baseURLGlobal;
	var url = new URL(window.location.href);
	var token = url.searchParams.get('token');

	useEffect(() => {
		var myHeaders = new Headers();
		myHeaders.append('x-access-token', token);
		var requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow',
		};
		fetch(`${baseUrl}/v1/campaign/homeCard`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				setData(result.data);
			});
	}, []);

	let coinTasksData = data?.statCardWeb?.filter(item => item?.isComplete === false);
	let bottomCardWebData = data?.bottomCardWeb;
	const campaignOrg = data?.campaignOrg;

	return (
		<>
		{!props?.isLoading ? (
			<div className="campaign-web">
				<div className="campaign-web-left">
					<div className="campaignTopCard">
						<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-web-top-card.png" alt={'img'} />
					</div>
					<div className="campaign-revenueContainer">
						<div className="campaign-revenue">
							<span className="campaign-border"></span>
							<div className="campaign-yourRevenue">YOUR REVENUE</div>
							<div className="campaign-revenueValue">
								{data?.homeCard?.revenueCard?.total}
							</div>
						</div>
						<div className="campaign-progressBar">
							<ProgressMeter
								width={data?.homeCard?.revenueCard?.progressBar > 100 ? 100 : data?.homeCard?.revenueCard?.progressBar}
								// data?.percentage
								// mileStoneData={
								//   data?.homeMileStone?.nextMilestone?.mileStoneData
								// }
								bgColor={'#F5885938'}
								thick={18}
								isQualified={true}
								data={data?.homeMileStone?.revenue}>
							</ProgressMeter>
						</div>
						<div className="progress-completed">
							<div className='progressCompletedWrapper'>
								{data?.homeCard?.revenueCard?.progressBar >= 100 ? '100' : data?.homeCard?.revenueCard?.progressBar}% Completed
							</div>
							<div className='milsStoneColour'>Goal: {data?.homeCard?.revenueCard?.goal}</div>
						</div>
					</div>
					<div className="campaign-cards-group">
						<div className="campaign-card">
							<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-point-icon.png" alt="cards" width={24} height={24}/>
							<h3>{data?.homeCard?.revenueCard?.points}</h3> POINTS
						</div>
					</div>
					<hr className="campaign-hr"/>
					<div className="sleekCarouselContainer">
						<SleekCarousel bottomCardData={bottomCardWebData} campaignOrg={campaignOrg}/>
					</div>
				</div>
				<div className="campaign-web-right">
					<div className='coinTaskTitleWrapper'>
						<hr />
						<div className='h2'>Collect cards & <br/> win exciting rewards!</div>
					</div>

					<div className='taskContainerWrapper'>
						{coinTasksData?.slice(0,3)?.map((item)=>{
							if (item?.task !== 'Send 5 notifications today') {
								return (
									<div className='taskContainer'>
										<div className='taskCardFirstRow'>
											<div className='taskCardUpperRow'>
												<div className='taskTitleWrapper'>
													<p className='taskTitle'>{item?.task}</p>
													{/*{item?.statType == 3 ? (*/}
													{/*	<p className='taskTitleSmall'>{item?.completedText}</p>*/}
													{/*) : (*/}
													{/*	<p className='taskTitleSmall'>{item?.total || 0} {item?.completedText}</p>*/}
													{/*)}*/}
												</div>
												<div>
													<ProgressMeter
														width={item?.percentage}
														isQualified={true}
														data={data?.homeMileStone?.revenue}
													></ProgressMeter>
												</div>
											</div>
											<div className='taskCoinWrapper'>
												<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-point-icon.png" alt="circle-point" width={20} height={20}/>
												<p className='taskTitleSmall'>{item?.points} Points</p>
											</div>
											<div className='taskCoinWrapper'>
												<button className='taskCardBtn'
														onClick={() => {directDeepLink(item?.button?.deeplink?.paramOne, SOURCE_HOME);window.open(item?.button?.deeplink?.paramOne)}}>{item?.button?.text}
												</button>
											</div>
										</div>
										<span className='dividerLine'></span>
										<div className='taskCardSecondRow'>
											{item?.taskInfo}
										</div>
									</div>
							)}
						})}
						{coinTasksData?.length > 3 && <div className='bottomFrames'>
							<div className='bottomCardFrame1'></div>
							<div className='bottomCardFrame2'></div>
						</div>}
						{coinTasksData?.length === 0 && <div className='taskContainer' style={{alignItems:'center', padding:'3em 2em'}}>
							<p className='coinTaskTitle'>TASKS COMPLETED</p>
						</div>}
					</div>
				</div>
			</div>
		) : (<>loading....</>)
		}
		</>
	);
};

export default withRouter(Campaign);
